import React from 'react';
import { Header, HeaderRow, HeaderCell } from '@table-library/react-table-library/table';
import CustomTooltip from 'components/tooltip/CustomTooltip';
const ProjectTableHeader: React.FC<{ showSizes: boolean }> = ({ showSizes }) => {
  return (
    <Header>
      <HeaderRow>
        <HeaderCell>
          Grid
          <CustomTooltip
            title={'Simulation results sharing the same grid can be opened jointly in the 3D visualizer'}
          />
        </HeaderCell>
        <HeaderCell> </HeaderCell>
        <HeaderCell className="center-cell">Status</HeaderCell>
        <HeaderCell className="center-cell">{showSizes ? 'Size' : ''}</HeaderCell>
        <HeaderCell className="center-cell">Info</HeaderCell>
        <HeaderCell className="center-cell">Actions</HeaderCell>
        <HeaderCell className="center-cell">Add</HeaderCell>
      </HeaderRow>
    </Header>
  );
};

export default ProjectTableHeader;
